import api from '@/apis/di/voucherTypeAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('voucherType', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_voucher_type',
    field: {
      key: 'voucher_type_id',
      code: 'voucher_type_code',
      name: 'voucher_type_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
